//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2ExportProcMenu', {
//        templateUrl: 'views/components/views/p2ExportProcMenu/p2ExportProcMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'p2ExportProcMenuService', function ($stateParams, p2ExportProcMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let p2ExportProcKeyno = $stateParams.p2_exportproc_keyno;
            
//            vm.model = {
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadMenu() {
//                vm.model.menu = (await p2ExportProcMenuService.getMenu({ p2_exportproc_keyno: p2ExportProcKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
